(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["queeries-trust-rotator"] && !Shopify.designMode) return;
  try {
    class QueeriesTrustRotator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.items = Array.from(this.querySelectorAll('.queeries-trust-rotator__item'));
      this.index = Math.max(
        0,
        this.items.findIndex((item) => item.classList.contains('is-active'))
      );

      if (this.items.length <= 1 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const interval = Number(this.dataset.interval) || 4700;
      this.timer = window.setInterval(() => {
        this.show((this.index + 1) % this.items.length);
      }, interval);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      window.clearTimeout(this.cleanupTimer);
    }

    show(nextIndex) {
      if (nextIndex === this.index) return;

      const current = this.items[this.index];
      const next = this.items[nextIndex];

      next.hidden = false;

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');

      next.classList.remove('is-leaving', 'is-active');
      next.classList.add('is-entering');
      next.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          next.classList.remove('is-entering');
          next.classList.add('is-active');
        });
      });

      window.clearTimeout(this.cleanupTimer);
      this.cleanupTimer = window.setTimeout(() => {
        current.classList.remove('is-leaving');
        current.hidden = true;
      }, 560);

      this.index = nextIndex;
    }
  }

  if (!customElements.get('queeries-trust-rotator')) {
    customElements.define('queeries-trust-rotator', QueeriesTrustRotator);
  }
  } catch(e) { console.error(e); }
})();

})();
